import React, { useEffect, useState } from 'react';
import '@/pages/intelligence/assets/scss/TopCharts/MobileGames/components/Stats.scss';
import { Segment } from 'tea-component';
import Loading from '@/pages/intelligence/components/Loading';
import TipContext from '@/pages/home/components/TipContextComponents/TipContext';
import ApnnieNochange from '@/pages/intelligence/assets/svg/dataSource/appnnie.svg';
import TableHeade from '@/pages/intelligence/assets/svg/dataSource/sensor-tower.svg';
import ActiveUserContext from './ActiveUserContext/Pages/Activeuser';
import RevenueContext from './ActiveUserContext/Pages/Revenue';
import DownloadsContext from './ActiveUserContext/Pages/Downloads';
import RetentionContex from './RetentionLifetime';
import RPDContext from './RPDContext/Page';
import { buriedPointGame } from '@/pages/home/utils/buriedPoint';
import { DBI_TOPCHARTS } from '@/pages/intelligence/models/topcharts';
import RetentionMonthly from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/RetentionMonthly/Page';
import PCStats from '@/pages/intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats';
import ConsoleStats from '@/pages/intelligence/pages/TopCharts/ConsoleGames/components/GamesDetails/Stats';
import { useDispatch, history, connect, useIntl } from 'umi';
import { FILTER_EXTEND_NAMESPACE } from '@/pages/intelligence/models/filterExtend';
import { getStatsPageLogMes, getCountroesPageLogMes } from './_config';
import PCConsoleStats from '@/pages/intelligence/pages/TopCharts/PCConsoleGames/components/GamesDetails/Stats';
import { PC_CONSOLE_COMBINE_ENTITY_TYPE } from '@intelligence/pages/TopCharts/_config/topChartsConst';
import useRadioOptionsTipsGetterOfRegionSelect from '@intelligence/hooks/useRadioOptionsTipsGetterOfRegionSelect';
import { MOBILE_STATS_REVENUE_SCOPE_SLOT_ID } from './ActiveUserContext/MobileStatsRevenueScopePortal';
import { useMobileStatsInitialTabRedirect } from './_hook';

const RETENTION_LIFETIME_SEGMENT = 'retention_lifetime';
const RETENTION_MONTHLY_SENSOR_TOWER_SEGMENT = 'retention_monthly_sensortower';
const RETENTION_MONTHLY_DATA_AI_SEGMENT = 'retention_monthly';
const RETENTION_SUB_SEGMENTS = [
  RETENTION_LIFETIME_SEGMENT,
  RETENTION_MONTHLY_SENSOR_TOWER_SEGMENT,
  RETENTION_MONTHLY_DATA_AI_SEGMENT,
];

const MONTHLY_RETENTION_SOURCE_PAIR = [
  RETENTION_MONTHLY_SENSOR_TOWER_SEGMENT,
  RETENTION_MONTHLY_DATA_AI_SEGMENT,
];

const clearDetailFilterExtend = (dispatch: any) => {
  dispatch({
    type: `${FILTER_EXTEND_NAMESPACE}/saveDetailFilterExtendCommon`,
    payload: null,
  });
  dispatch({
    type: `${FILTER_EXTEND_NAMESPACE}/saveIsOperateDetail`,
    payload: false,
  });
};

export default function Stats(props: any) {
  const { entityType } = props;

  const getRadioOptionsTips = useRadioOptionsTipsGetterOfRegionSelect();

  if (entityType === 'mobile') {
    return <MobileStats {...props} tabType={'stats'} />;
  }
  if (entityType === 'pc') {
    return <PCStats {...props} tabType={'stats'} />;
  }
  if (entityType === 'console') {
    return <ConsoleStats {...props} tabType={'stats'} getRadioOptionsTips={getRadioOptionsTips} />;
  }
  if (entityType === PC_CONSOLE_COMBINE_ENTITY_TYPE) {
    return (
      <div className="pc-console-stats-details">
        <PCConsoleStats {...props} tabType={'stats'} getRadioOptionsTips={getRadioOptionsTips} />
      </div>
    );
  }
  return null;
}

export function MobileStats(props: any) {
  const {
    gameId,
    tabType = 'stats',
    activeId,
    entityType,
    moduleName,
    activeSegment,
    isBasicLoading,
    appIds,
    markManualStatsSegmentSwitch,
    isManualStatsSegmentSwitch,
  } = props;

  const { formatMessage } = useIntl(); // 中英切换方法

  const mainOptionList = [
    { text: formatMessage({ id: `dbi_active_users` }), value: 'activeusers' },
    { text: formatMessage({ id: `dbi_revenue` }), value: 'revenue' },
    { text: formatMessage({ id: `dbi_downloads` }), value: 'downloads' },
    { text: formatMessage({ id: `dbi_retention` }), value: 'retention' },
    { text: formatMessage({ id: `dbi_rpd` }), value: 'rpd' },
  ];

  const subOptionList = [
    {
      text: (
        <div className="retention-segment-flex">
          <img src={TableHeade} className="retention-img" />
          <span className="retention-text">
            {formatMessage({ id: `dbi_lifetime_retention` })}
          </span>
        </div>
      ),
      value: RETENTION_LIFETIME_SEGMENT,
    },
    {
      text: (
        <div className="retention-segment-flex">
          <img src={TableHeade} className="retention-img" />
          <span className="retention-text">
            {formatMessage({ id: `dbi_monthly_retention` })}
          </span>
        </div>
      ),
      value: RETENTION_MONTHLY_SENSOR_TOWER_SEGMENT,
    },
    {
      text: (
        <div className="retention-segment-flex">
          <img src={ApnnieNochange} className="retention-img" />
          <span className="retention-text">
            {formatMessage({ id: `dbi_monthly_retention` })}
          </span>
        </div>
      ),
      value: RETENTION_MONTHLY_DATA_AI_SEGMENT,
    },
  ];

  const mainOptionsValues = mainOptionList?.map((item) => {
    return item.value;
  });

  const getMainSegement = (activeSegment: string) => {
    if (RETENTION_SUB_SEGMENTS.includes(activeSegment)) {
      return 'retention';
    }
    return mainOptionsValues?.includes(activeSegment)
      ? activeSegment
      : mainOptionsValues[0];
  };

  const [mainSegment, setMainSegment] = useState<string>(
    getMainSegement(activeSegment),
  );
  const [subSegment, setSubSegment] = useState<string>(activeSegment);
  // const [activeSegment, setUrlTab] = useState(activeSegment);
  const [loading, setLoading] = useState(true); // 用于给segment, loading时禁用， 也可以存在model中
  const [destroyed, setDestroyed] = useState(false);
  /** ST↔data.ai 月度切换递增：子页用默认筛选、不继承短链/详情继承 */
  const [monthlyRetentionIsolationKey, setMonthlyRetentionIsolationKey] =
    useState(0);

  useEffect(() => {
    const nextMainSegment = getMainSegement(activeSegment);
    setMainSegment(nextMainSegment);
    if (nextMainSegment === 'retention' && RETENTION_SUB_SEGMENTS.includes(activeSegment)) {
      setSubSegment(activeSegment);
    }
  }, [activeSegment]);

  const dispatch = useDispatch();

  useEffect(() => {
    handlePageLog(activeSegment, gameId);
  }, []);

  const handlePageLog = (tab: string, gameId: string) => {
    const pageLogMes =
      tabType === 'countries'
        ? getCountroesPageLogMes(entityType, tab)
        : getStatsPageLogMes(entityType, tab);
    if (gameId && pageLogMes) {
      buriedPointGame(pageLogMes, gameId);
    }
    // 每次打点的时候，记录当前打点信息用于详情页头部的feedback参数
    recordPageMesForFeedback(pageLogMes);
  };

  const recordPageMesForFeedback = (logMes: any) => {
    dispatch({
      type: `${DBI_TOPCHARTS}/setActivedPageLogMes`,
      payload: logMes,
    });
  };

  const changeUrl = (
    activeSubTab: string,
    opts?: { clearQuery?: boolean },
  ) => {
    const pathname = `/intelligence/topCharts/${
      moduleName || 'mobileGames'
    }/gamesDetails/${gameId}/${activeId}/${activeSubTab}`;
    if (opts?.clearQuery) {
      history.replace({ pathname, query: {} });
      return;
    }
    history.replace(pathname);
  };

  const { isInitialTabChecking, markManualTabSwitch } =
    useMobileStatsInitialTabRedirect({
      gameId,
      appIds,
      isBasicLoading,
      tabType,
      activeSegment,
      isManualTabSwitch: isManualStatsSegmentSwitch,
      onRedirect: changeUrl,
    });

  return (
    <div className="dbi-mobile-games-stats">
        <div className="mobile-games-flex">
          <Segment
            className="segment-light games-left"
            value={mainSegment}
            onChange={(value) => {
              markManualStatsSegmentSwitch?.();
              markManualTabSwitch();
              let activeSegmentForUrl = value;
              // TODO 有子标签的需要设置默认值
              if (value === 'retention') {
                setSubSegment(RETENTION_MONTHLY_SENSOR_TOWER_SEGMENT);
                activeSegmentForUrl = RETENTION_MONTHLY_SENSOR_TOWER_SEGMENT;
              }
              // setActiveSegment(activeSegmentForUrl);
              setMainSegment(value);
              handlePageLog(activeSegmentForUrl, gameId);
              setDestroyed(true);
              setTimeout(() => {
                setDestroyed(false);
              }, 0);
              changeUrl(activeSegmentForUrl);
            }}
            options={mainOptionList}
          />
          {tabType === 'stats' && (
            <TipContext
              AWidth={600}
              className="games-left-tip"
              tipText={formatMessage({ id: `dbi_stats_segement_info` })}
            />
          )}
          {tabType === 'stats' && mainSegment === 'revenue' && (
            <div
              id={MOBILE_STATS_REVENUE_SCOPE_SLOT_ID}
              className="mobile-games-flex-right"
            />
          )}
        {mainSegment == 'retention' ? (
          <>
            <Segment
              className="segment-light retention-segment"
              value={subSegment}
              onChange={(value) => {
                markManualStatsSegmentSwitch?.();
                markManualTabSwitch();
                const prevSub = subSegment;
                const switchMonthlySource =
                  MONTHLY_RETENTION_SOURCE_PAIR.includes(value) &&
                  MONTHLY_RETENTION_SOURCE_PAIR.includes(prevSub) &&
                  value !== prevSub;
                if (switchMonthlySource) {
                  clearDetailFilterExtend(dispatch);
                  setMonthlyRetentionIsolationKey((k) => k + 1);
                }
                setSubSegment(value);
                handlePageLog(value, gameId);
                // setActiveSegment(value);
                changeUrl(value, {
                  clearQuery: switchMonthlySource,
                });
              }}
              options={subOptionList}
            />
          </>
        ) : (
          ''
        )}
      </div>
      {isInitialTabChecking ? (
        <Loading content={formatMessage({ id: 'common_loading' })} />
      ) : destroyed ? null : [
        RETENTION_MONTHLY_DATA_AI_SEGMENT,
        RETENTION_MONTHLY_SENSOR_TOWER_SEGMENT,
      ].includes(activeSegment) ? (
        <RetentionMonthly
          key={`${activeSegment}-${monthlyRetentionIsolationKey}`}
          {...props}
          monthlyRetentionIsolationKey={monthlyRetentionIsolationKey}
          pageId={`${mainSegment}—${subSegment}`}
          tabType={tabType}
          loading={loading}
          setLoading={setLoading}
          entityType={entityType}
          dataSource={
            activeSegment === RETENTION_MONTHLY_SENSOR_TOWER_SEGMENT
              ? 'sensortower'
              : 'appannie'
          }
        />
      ) : activeSegment == RETENTION_LIFETIME_SEGMENT ? (
        <RetentionContex
          {...props}
          pageId={`${mainSegment}—${subSegment}`}
          value={subSegment}
          tabType={tabType}
          loading={loading}
          setLoading={setLoading}
          entityType={entityType}
        />
      ) : activeSegment == 'rpd' ? (
        <RPDContext
          {...props}
          pageId={mainSegment}
          tabType={tabType}
          loading={loading}
          setLoading={setLoading}
          entityType={entityType}
        />
      ) : activeSegment == 'revenue' ? (
        <RevenueContext
          {...props}
          pageId={mainSegment}
          tabType={tabType}
          loading={loading}
          setLoading={setLoading}
        />
      ) : activeSegment == 'downloads' ? (
        <DownloadsContext
          {...props}
          pageId={mainSegment}
          tabType={tabType}
          loading={loading}
          setLoading={setLoading}
        />
      ) : (
        <ActiveUserContext
          {...props}
          pageId={mainSegment}
          tabType={tabType}
          loading={loading}
          setLoading={setLoading}
          entityType={entityType}
        />
      )}
    </div>
  );
}

connect((state: any) => {
  return {
    topchartsState: state[DBI_TOPCHARTS],
  };
})(MobileStats);
